import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PricingBoxProps {
  onCTAClick?: () => void;
}
export function PricingBox({
  onCTAClick
}: PricingBoxProps) {
  return <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 border-4 border-[#D4AF37] relative overflow-hidden" data-id="element-50">
      <div className="absolute top-0 right-0 bg-[#D4AF37] text-white px-6 py-2 rounded-bl-2xl font-bold flex items-center gap-2" data-id="element-51">
        <Sparkles className="w-4 h-4" data-id="element-52" />
        OFERTA ESPECIAL
      </div>

      <div className="text-center mb-8 mt-8" data-id="element-53">
        <h3 className="text-3xl md:text-4xl font-bold text-[#8B7355] mb-4" data-id="element-54">
          Los Secretos de la Abuela
        </h3>
        <p className="text-lg text-[#3A3226] mb-6" data-id="element-55">
          Manual Completo + Bono Gratis Incluido
        </p>

        <div className="mb-6" data-id="element-56">
          <span className="text-5xl md:text-6xl font-bold text-[#D4AF37]" data-id="element-57">
            $11.97
          </span>
          <span className="text-xl text-[#8B7355] line-through ml-3" data-id="element-58">$47</span>
        </div>

        <p className="text-sm text-[#8B7355]/70 mb-8" data-id="element-59">
          Precio especial de lanzamiento - Por tiempo limitado
        </p>

        <div className="mb-8" data-id="element-60">
          <img src="https://cdn.magicpatterns.com/uploads/vc5oytTuCSbT5qaWmuFnmV/secretos-abuela-boton-comprar-fondo-blanco.png" alt="Los Secretos de la Abuela en múltiples dispositivos" className="w-full max-w-md mx-auto" data-id="element-61" />
        </div>
      </div>

      <div className="space-y-4 mb-8" data-id="element-62">
        <div className="flex items-start gap-3" data-id="element-63">
          <Check className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-64" />
          <p className="text-[#3A3226]" data-id="element-65">
            <strong data-id="element-66">Libro digital completo</strong> con más de 50 remedios
            naturales
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-67">
          <Check className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-68" />
          <p className="text-[#3A3226]" data-id="element-69">
            <strong data-id="element-70">BONO:</strong> 21 Recetas de Limpieza Express
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-71">
          <Check className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-72" />
          <p className="text-[#3A3226]" data-id="element-73">
            <strong data-id="element-74">Acceso inmediato</strong> - Descarga en segundos
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-75">
          <Check className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-76" />
          <p className="text-[#3A3226]" data-id="element-77">
            <strong data-id="element-78">Funciona en celular, tablet y computadora</strong>
          </p>
        </div>
        <div className="flex items-start gap-3" data-id="element-79">
          <Check className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-80" />
          <p className="text-[#3A3226]" data-id="element-81">
            <strong data-id="element-82">Acceso de por vida</strong>
          </p>
        </div>
      </div>

      <CTAButton onClick={onCTAClick} data-id="element-83" />

      <div className="mt-8" data-id="element-84">
        <a href="https://impactlifemethod.com/cart/48185238814944:1" className="block w-full bg-[#D4AF37] hover:bg-[#C4A027] text-white px-8 py-4 rounded-full text-xl font-bold transition-all hover:scale-105 active:scale-95 shadow-lg text-center" data-id="element-85">
          Sí, lo quiero AHORA
        </a>
      </div>

      <p className="text-center text-sm text-[#8B7355]/70 mt-6" data-id="element-86">
        🔒 Pago seguro y encriptado
      </p>
    </div>;
}